import request from "utils/request";

export async function getStrategies() {
	return request("/rest/strategies");
}

export async function createStrategy(payload) {
	return request("/rest/strategies", {
		method: "POST",
		body: payload
	});
}

export async function saveStrategy(payload) {
	return request("/rest/strategies/" + payload.id, {
		method: "PUT",
		body: payload
	});
}

export async function deleteStrategies(ids) {	
	return request("/rest/delete/strategies", {
		method: "POST",
		body: ids
	});
}

export async function getStrategy(id) {
	return request("/rest/strategies/" + id);
}

export async function duplicateStrategy(payload) {
	return request("/action/duplicate/strategy", {
		method: "POST",
		body: payload
	});
}
